import { Fragment, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { urlWithParams } from '../../../services/Util';

export default function Imagegallery({
	onClick,
	id: buttonId,
	value,
	label,
	format,
	imgMaxWidth,
	imgMaxHeight,
}) {
	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [modalOpen, setModalOpen] = useState(false);

	if (!value || !value.length) {
		return false;
	}

	format = format ? format : '';

	function closeModal(e) {
		setModalOpen(false);
	}

	function openModal(e) {
		onClick(e, buttonId);
		setModalOpen(true);
	}

	function incrementCurrentImageIndex() {
		setCurrentImageIndex((currentImageIndex + 1) % value.length);
	}

	function decrementCurrentImageIndex() {
		setCurrentImageIndex((currentImageIndex + value.length - 1) % value.length);
	}

	function doSetCurrentImageIndex(e) {
		const key = e.target.dataset.key;
		setCurrentImageIndex(Number(key));
		openModal(e);
	}

	const images = value.map((img, key) => {
		return (
			<StyledCarouselItem
				key={key}
				maxWidth={imgMaxWidth}
				maxHeight={imgMaxHeight}
				className={`carousel-item ${key === currentImageIndex ? 'active' : ''}`}
			>
				<div className="slp-slideshow-slide">
					<img src={img.url} className="d-block" title={img.title} alt={img.alt} />
				</div>
			</StyledCarouselItem>
		);
	});

	const currentImage = value.find((img, key) => {
		return key === currentImageIndex;
	});

	return (
		<>
			<StyledImageGallery className={`container slp-Section slp-Imagegallery`}>
				{('' === format || 'grid' === format || 'slideshow' === format) && (
					<Fragment>
						{'slideshow' === format && (
							<StyledSlideshowSlide maxWidth={imgMaxWidth} maxHeight={imgMaxHeight}>
								<div className="slp-slideshow-slide">
									<img
										src={currentImage.url}
										className="d-block"
										title={currentImage.title}
										alt={currentImage.alt}
									/>
								</div>
							</StyledSlideshowSlide>
						)}
						<StyledImageGrid>
							{value.map((img, key) => {
								return (
									<StyledImageGridItem
										key={key}
										data-key={key}
										to={urlWithParams({ m: 'image', url: img.url, title: img.title, alt: img.alt })}
									>
										<img src={img.url} className="img-fluid" title={img.title} alt={img.alt} />
									</StyledImageGridItem>
								);
							})}
						</StyledImageGrid>
					</Fragment>
				)}

				{'carousel' === format && (
					<StyledCarousel className="carousel slide" data-ride="carousel">
						<div className="carousel-inner">{images}</div>
						<a className="carousel-control-prev" onClick={decrementCurrentImageIndex}>
							<span className="carousel-control">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path d="M3 12l18-12v24z" />
								</svg>
							</span>
						</a>
						<a className="carousel-control-next" onClick={incrementCurrentImageIndex}>
							<span className="carousel-control">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path d="M21 12l-18 12v-24z" />
								</svg>
							</span>
						</a>
					</StyledCarousel>
				)}

				{label && label.length && <p>{label}</p>}
			</StyledImageGallery>
		</>
	);
}

const StyledImageGallery = styled.div`
	margin-bottom: 1rem;
`;

const StyledImageGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.618rem;
	justify-content: center;
	margin-bottom: 1rem;
`;

const StyledImageGridItem = styled(Link)`
	align-items: center;
	border: 1px solid #dee2e6;
	cursor: pointer;
	display: flex;
	flex: 1 0 calc(25% - 0.618rem);
	justify-content: center;
	min-height: 5rem;
	max-width: calc(25% - 0.618rem);

	img {
		pointer-events: none;
	}
`;

const StyledCarousel = styled.div`
	.carousel-inner {
		border: 1px solid #dee2e6;
	}

	.carousel-control {
		align-items: center;
		background: white;
		display: flex;
		justify-content: center;
		padding: 1.618rem 0;
		width: 100%;

		svg {
			height: 1.618rem;
			width: 1.618rem;
		}
	}
`;

const StyledCarouselItem = styled.div`
	height: 0;
	min-height: 5rem;
	padding-bottom: ${(props) => `${(props.maxHeight / props.maxWidth) * 100}%;`};

	&.active {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.slp-slideshow-slide {
		align-items: center;
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		// padding: 0.618rem;
		position: absolute;
		right: 0;
		top: 0;
	}

	img {
		object-fit: contain;
		height: 100%;
		width: 100%;
	}
`;

const StyledSlideshowSlide = styled.div`
	border: 1px solid #dee2e6;
	cursor: pointer;
	height: 0;
	margin-bottom: 0.618rem;
	min-height: 5rem;
	padding-bottom: ${(props) => `${(props.maxHeight / props.maxWidth) * 100}%;`};
	position: relative;

	.slp-slideshow-slide {
		align-items: center;
		bottom: 0.618rem;
		display: flex;
		justify-content: center;
		left: 0.618rem;
		position: absolute;
		right: 0.618rem;
		top: 0.618rem;
	}

	img {
		object-fit: contain;
		height: 100%;
		width: 100%;
	}
`;
